<ng-container *transloco="let t; read: 'function-archive'">
  <h1>{{ t("title") }}</h1>
  <section class="article">
    <article>
      <h2>{{ t("title-2-4") }}</h2>
      <div class="text">
        <ul class="functions" [innerHTML]="t('content-2-4')"></ul>
      </div>
    </article>
    <article>
      <h2>{{ t("title-2-0") }}</h2>
      <div class="text">
        <ul class="functions" [innerHTML]="t('content-2-0')"></ul>
      </div>
    </article>
    <article>
      <h2>{{ t("title-1-4") }}</h2>
      <div class="text">
        <ul class="functions" [innerHTML]="t('content-1-4')"></ul>
      </div>
    </article>
    <article>
      <a class="call" onclick="window.history.back()">{{ t("back-button") }}</a>
    </article>
  </section>
</ng-container>
